/* eslint-disable complexity */
/* istanbul ignore file */
import {Locale} from '@aboutyou/config';
import {assertUnreachable} from '@aboutyou/utils';

export interface SpecialCategoryConfig {
  clothing: string;
  new: string;
  sale: string;
  sport: string;
  outfits: string;
}

export function getSpecialCategoriesByLocale_UNSAFE(
  locale: Locale,
): SpecialCategoryConfig {
  switch (locale) {
    case Locale.de_DE:
    case Locale.de_AT:
    case Locale.de_CH:
      return {
        clothing: 'bekleidung',
        new: 'neu',
        sale: 'sale',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.nl_NL:
    case Locale.nl_BE:
      return {
        clothing: 'kleding',
        new: 'nieuw',
        sale: 'sale',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.fr_BE:
    case Locale.fr_CH:
    case Locale.fr_FR:
      return {
        clothing: 'vetements',
        new: 'nouveautes',
        sale: 'soldes',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.fr_LU:
      return {
        clothing: 'vetements',
        new: 'nouveautes',
        sale: 'promos',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.pl_PL:
      return {
        clothing: 'odziez',
        new: 'nowosci',
        sale: 'sale',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.cs_CZ:
      return {
        clothing: 'obleceni',
        new: 'nove',
        sale: 'sale',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.sk_SK:
      return {
        clothing: 'oblecenie',
        new: 'nove',
        sale: 'vypredaj',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.ro_RO:
      return {
        clothing: 'haine',
        new: 'noutati',
        sale: 'sale',
        sport: 'sport',
        outfits: 'outfituri',
      };

    case Locale.hu_HU:
      return {
        clothing: 'ruhazat',
        new: 'uj',
        sale: 'akciok',
        sport: 'sport',
        outfits: 'outfitek',
      };

    case Locale.sl_SI:
      return {
        clothing: 'oblacila',
        new: 'novo',
        sale: 'razprodaja',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.lv_LV:
      return {
        clothing: 'apgerbi',
        new: 'jaunumi',
        sale: 'izpardosana',
        sport: 'sports',
        outfits: 'outfits',
      };

    case Locale.lt_LT:
      return {
        clothing: 'drabuziai',
        new: 'naujiena',
        sale: 'ispardavimas',
        sport: 'sportas',
        outfits: 'outfits',
      };

    case Locale.et_EE:
      return {
        clothing: 'riided',
        new: 'uus',
        sale: 'allahindlus',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.hr_HR:
      return {
        clothing: 'odjeca',
        new: 'novo',
        sale: 'rasprodaja',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.bg_BG:
      return {
        clothing: 'drehi',
        new: 'xxx',
        sale: 'promotsii',
        sport: 'sportni',
        outfits: 'outfits',
      };

    case Locale.en_ZZ:
    case Locale.da_DK:
    case Locale.en_DE:
    case Locale.sv_SE:
    case Locale.fi_FI:
    case Locale.en_AT:
    case Locale.en_CH:
    case Locale.en_NL:
      return {
        clothing: 'clothing',
        new: 'new',
        sale: 'sale',
        sport: 'sports',
        outfits: 'outfits',
      };

    case Locale.es_ZZ:
    case Locale.es_ES:
      return {
        clothing: 'ropa',
        new: 'nuevo',
        sale: 'rebajas',
        sport: 'deporte',
        outfits: 'outfits',
      };

    case Locale.it_IT:
    case Locale.it_CH:
      return {
        clothing: 'abbigliamento',
        new: 'nuovo',
        sale: 'promo',
        sport: 'sport',
        outfits: 'outfits',
      };

    case Locale.pt_PT:
      return {
        clothing: 'roupas',
        new: 'novas',
        sale: 'promocao',
        sport: 'desporto',
        outfits: 'outfits',
      };
    case Locale.el_CY:
    case Locale.el_GR:
      return {
        clothing: 'roucha',
        new: 'nea',
        sale: 'ekptoseis',
        sport: 'athletika',
        outfits: 'outfits',
      };

    case Locale.ru_EE:
    case Locale.ru_LV:
      return {
        clothing: 'odezhda',
        new: 'novinki',
        sale: 'rasprodazha',
        sport: 'sport',
        outfits: 'obrazy',
      };

    default:
      assertUnreachable(locale);
  }
}
